<template>
    <div class="otherHanfleList">
        <div class="search-content" style="margin-top:16px;" v-if="(actived==1||actived==5)">
            <div class="mainBtn">
                <el-button
                    @click="add"
                    size="small"
                    type="primary"
                    v-if="hasBtnPermission('online_complaints_btn_add')"
                >新增</el-button>
            </div>
        </div>
        <div  v-if="actived!=1||actived!=5" :style="`${(actived==1||actived==5)?'':'width:100%;height:10px;background-color:#fff;margin-top:16px;'}`" ></div>
        <el-table
            class="table-content"
            :data="tableData"
            @sort-change="sortChange"
            v-loading="dataListLoading"
            :height="tableHeight"
            :header-cell-style="this.$globalGrayTableHeaderStyle"
            stripe
            border
            ref="othertableRef"
        >
            <el-table-column
                :index="indexMethod"
                align="center"
                label="序号"
                type="index"
                width="50"
                :show-overflow-tooltip="true"
                fixed="left"
                :key="1"
            ></el-table-column>
            <el-table-column
                prop="receiveStatusName"
                header-align="left"
                align="left"
                min-width="150"
                :show-overflow-tooltip="true"
                :key="2"
                v-if="activedTab!='processed'"
            >
                <template slot="header" slot-scope="scope">
                    <el-popover
                        placement="bottom"
                        width="200"
                        trigger="click"
                        :ref="`popover-${scope.$index}`"
                    >
                        <span
                            slot="reference"
                            style="cursor: pointer;margin-top:10px"
                            :style="{color:checkReceiveStatus.length>0?'#1890ff':''}"
                        >
                            {{activedTab=='pending'?'本部门处理状态':'受理状态'}}
                            <img
                                src="../../../../../assets/img/shaixuan.png"
                                alt
                            />
                        </span>
                        <div>
                            <div id="el-checkbox-group">
                                <el-checkbox-group v-model="checkReceiveStatus">
                                    <el-checkbox
                                        :label="item.value"
                                        v-for="(item,index) in processingStateList"
                                        :key="index"
                                        class="check_box"
                                    >{{item.label}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button type="primary" size="mini" @click="getDataList">筛选</el-button>
                                <el-button size="mini" plain @click="cancelReceive">重置</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
                <template slot-scope="scope">
                    <i :class="formatterStatusClass(scope.row.receiveStatus)"></i>
                    <span>{{scope.row.receiveStatusName}}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="activedTab=='processed'||activedTab=='all'"
                label="本部门处理结果"
                prop="owerDeptHandleResult"
                header-align="left"
                align="left"
                min-width="140"
                :show-overflow-tooltip="true"
                :key="19"
            >
                <template slot="header" slot-scope="scope">
                    <el-popover
                        placement="bottom"
                        width="200"
                        trigger="click"
                        :ref="`popover-${scope.$index}`"
                    >
                        <span
                            slot="reference"
                            style="cursor: pointer;margin-top:10px"
                            :style="{color:checkOwerDeptHandleResult.length>0?'#1890ff':''}"
                        >
                            本部门处理结果
                            <img src="../../../../../assets/img/shaixuan.png" alt />
                        </span>
                        <div>
                            <div id="el-checkbox-group">
                                <el-checkbox-group v-model="checkOwerDeptHandleResult">
                                    <el-checkbox
                                        :label="item.code"
                                        v-for="(item,index) in checkReceiveOptions"
                                        :key="index"
                                        class="check_box"
                                    >{{item.name}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button type="primary" size="mini" @click="getDataList">筛选</el-button>
                                <el-button size="mini" plain @click="cancelDeptHandleResult">重置</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
                <template slot-scope="scope">
                    <i v-if="scope.row.owerDeptHandleResult" :class="formatterResultClass(scope.row.handleStatus)"></i>
                    <span>{{scope.row.owerDeptHandleResult?scope.row.owerDeptHandleResult:'--'}}</span>
                </template>
            </el-table-column>
            <!-- <el-table-column
                label="处理进度"
                prop="progress"
                align="left"
                min-width="460"
                :show-overflow-tooltip="true"
            ></el-table-column>-->
            <el-table-column
                v-if="activedTab=='pending'||activedTab=='processed'||activedTab=='all'"
                label="整体处理进度"
                prop="progress"
                align="left"
                min-width="460"
                :show-overflow-tooltip="true"
                :key="3"
            >
            <template slot-scope="scope">
                    <span>{{scope.row.progress?scope.row.progress:'--'}}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="投诉编号"
                prop="complaintCode"
                header-align="center"
                align="center"
                min-width="150"
                :show-overflow-tooltip="true"
                :key="4"
            >
                <template slot="header" slot-scope="scope">
                    <el-popover placement="bottom" trigger="click" width="200">
                        <p slot="reference" style="cursor: pointer;margin-top:10px">
                            投诉编号
                            <i class="el-icon-search"></i>
                        </p>
                        <div>
                            <div style="display: inline-block;padding:12px">
                                <el-input
                                    clearable
                                    placeholder="请输入投诉编号"
                                    v-model="complaintCodeSearch"
                                ></el-input>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button plain size="mini" @click="{complaintCodeSearch='';getDataList();}">重置</el-button>
                                <el-button
                                    @click="searchChoseTimefunc(complaintCodeSearch,4)"
                                    size="mini"
                                    type="primary"
                                >搜索</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column
                v-if="activedTab=='waitAccept'||activedTab=='all'"
                align="center"
                header-align="center"
                label="受理时效"
                min-width="100"
                prop="receiveTimeliness"
                :show-overflow-tooltip="true"
                :key="5"
            >
                <template slot-scope>--</template>
            </el-table-column>
            <el-table-column
                v-if="activedTab=='pending'||activedTab=='processed'||activedTab=='all'"
                align="center"
                header-align="center"
                label="处理时效"
                min-width="100"
                prop="handleRateName"
                :show-overflow-tooltip="true"
                :key="6"
            >
                <template slot="header" slot-scope="scope">
                    <el-popover
                        placement="bottom"
                        width="200"
                        trigger="click"
                        :ref="`popover-${scope.$index}`"
                    >
                        <span
                            slot="reference"
                            style="cursor: pointer;margin-top:10px"
                            :style="{color:handleRateChoseList.length>0?'#1890ff':''}"
                        >
                            处理时效
                            <img src="../../../../../assets/img/shaixuan.png" alt />
                        </span>
                        <div>
                            <div id="el-checkbox-group">
                                <el-checkbox-group v-model="handleRateChoseList">
                                    <el-checkbox
                                        :label="item.value"
                                        v-for="(item,index) in handleRateNameList"
                                        :key="index"
                                        class="check_box"
                                    >{{item.label}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button type="primary" size="mini" @click="getDataList">筛选</el-button>
                                <el-button size="mini" plain @click="cancelHandleRateNameList">重置</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
                <template slot-scope="scope">
                    <el-tag
                        :color="scope.row.handleRateColor?scope.row.handleRateColor:'#1890FF'"
                        style="color:#FFF;opacity: 0.6;border: none;"
                        v-if="scope.row.handleRateName"
                    >{{scope.row.handleRateName}}</el-tag>
                    <span v-else>--</span>
                </template>
            </el-table-column>

            <el-table-column
                label="项目(标段)名称"
                prop="bidSectionName"
                header-align="left"
                min-width="200"
                :show-overflow-tooltip="true"
                :key="7"
            >
            <template slot="header" slot-scope="scope">
                    <el-popover placement="bottom" trigger="click" width="220">
                        <p slot="reference" style="cursor: pointer;margin-top:10px">
                            项目(标段)名称
                            <i class="el-icon-search"></i>
                        </p>
                        <div>
                            <div style="display: inline-block;padding:12px">
                                <el-input
                                    clearable
                                    placeholder="请输入项目(标段)名称"
                                    v-model="bidSectionNameSearch"
                                ></el-input>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button plain size="mini" @click="{bidSectionNameSearch='';getDataList();}">重置</el-button>
                                <el-button
                                    @click="searchChoseTimefunc(bidSectionNameSearch,6)"
                                    size="mini"
                                    type="primary"
                                >搜索</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column
                label="项目(标段)编号"
                prop="bidSectionCode"
                align="center"
                header-align="center"
                min-width="230"
                :key="8"
                :show-overflow-tooltip="true"
            >
            <template slot="header" slot-scope="scope">
                    <el-popover placement="bottom" trigger="click" width="220">
                        <p slot="reference" style="cursor: pointer;margin-top:10px">
                            项目(标段)编号
                            <i class="el-icon-search"></i>
                        </p>
                        <div>
                            <div style="display: inline-block;padding:12px">
                                <el-input
                                    clearable
                                    placeholder="请输入项目(标段)编号"
                                    v-model="bidSectionCodeSearch"
                                ></el-input>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button plain size="mini" @click="{bidSectionCodeSearch='';getDataList();}">重置</el-button>
                                <el-button
                                    @click="searchChoseTimefunc(bidSectionCodeSearch,7)"
                                    size="mini"
                                    type="primary"
                                >搜索</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column
                label="投诉人员"
                prop="complainter"
                align="center"
                header-align="center"
                min-width="120"
                :key="20"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
            v-if="activedTab=='all'"
                label="投诉单位"
                prop="complainterUnit"
                align="center"
                header-align="center"
                min-width="120"
                :key="21"
                :show-overflow-tooltip="true"
            ></el-table-column>
            <el-table-column
             v-if="activedTab=='all'"
                label="被投诉单位"
                prop="appelleeUnits"
                align="center"
                header-align="center"
                min-width="120"
                :key="9"
                :show-overflow-tooltip="true"
            >
            <template slot-scope="scope">
                    <span>{{scope.row.appelleeUnits?scope.row.appelleeUnits:'--'}}</span>
            </template>
            </el-table-column>
            <el-table-column
                label="投诉提交时间"
                prop="submitTime"
                align="center"
                header-align="center"
                min-width="180"
                :key="10"
                :show-overflow-tooltip="true"
            >
                <template slot="header" slot-scope="scope">
                    <el-popover placement="bottom" trigger="click" width="300">
                        <span slot="reference" style="cursor: pointer;margin-top:10px">
                            投诉提交时间
                            <i class="el-icon-search"></i>
                            <!-- <span>
                <div> <i class="el-icon-caret-top"></i></div>
                <div> <i class="el-icon-caret-bottom"></i></div>
                            </span>-->
                        </span>
                        <div>
                            <div style="display: inline-block;padding:12px">
                                <el-date-picker
                                    v-model="submitTimeValue"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                    format="yyyy-MM-dd"
                                ></el-date-picker>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button plain size="mini" @click="()=>{submitTimeValue=[];submitTimeLE='';submitTimeGE='';getDataList()}">重置</el-button>
                                <el-button
                                    @click="searchChoseTimefunc(submitTimeValue,1)"
                                    size="mini"
                                    type="primary"
                                >搜索</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>

            <el-table-column
                label="投诉受理部门"
                prop="receiveOrgName"
                min-width="160"
                :show-overflow-tooltip="true"
                :key="11"
            >
                <template slot="header" slot-scope="scope">
                    <el-popover placement="bottom" trigger="click" width="220">
                        <p slot="reference" style="cursor: pointer;margin-top:10px">
                            投诉受理部门
                            <i class="el-icon-search"></i>
                        </p>
                        <div>
                            <div style="display: inline-block;padding:12px">
                                <el-input
                                    clearable
                                    placeholder="请输入投诉受理部门"
                                    v-model="receiveOrgNameSearch"
                                ></el-input>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button plain size="mini" @click="{receiveOrgNameSearch='';getDataList()}">重置</el-button>
                                <el-button
                                    @click="searchChoseTimefunc(receiveOrgNameSearch,5)"
                                    size="mini"
                                    type="primary"
                                >搜索</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
            </el-table-column>
            <el-table-column
                v-if="activedTab=='pending'||activedTab=='processed'||activedTab=='all'"
                label="投诉受理人员"
                prop="receiverName"
                header-align="center"
                align="center"
                min-width="120"
                :show-overflow-tooltip="true"
                :key="12"
            >
            <template slot-scope="scope">
                    <span>{{scope.row.receiverName?scope.row.receiverName:'--'}}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="activedTab=='pending'||activedTab=='processed'||activedTab=='all'"
                label="投诉受理时间"
                prop="receiveTime"
                header-align="center"
                align="center"
                min-width="160"
                :show-overflow-tooltip="true"
                :key="13"
            >
                <template slot="header" slot-scope="scope">
                    <el-popover placement="bottom" trigger="click" width="300">
                        <span slot="reference" style="cursor: pointer;margin-top:10px">
                            投诉受理时间
                            <i class="el-icon-search"></i>
                            <!-- <span>
                                    <div> <i class="el-icon-caret-top"></i></div>
                                    <div> <i class="el-icon-caret-bottom"></i></div>
                            </span>-->
                        </span>
                        <div>
                            <div style="display: inline-block;padding:12px">
                                <el-date-picker
                                    v-model="receiveTimeValue"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                ></el-date-picker>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button plain size="mini" @click="()=>{receiveTimeValue=[];receiveTimeLE='';receiveTimeGE='';getDataList()}">重置</el-button>
                                <el-button
                                    @click="searchChoseTimefunc(receiveTimeValue,2)"
                                    size="mini"
                                    type="primary"
                                >搜索</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
                <template slot-scope="scope">
                    <span>{{scope.row.receiveTime?scope.row.receiveTime:'--'}}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="activedTab=='processed'||activedTab=='all'"
                label="处理完成时间"
                fixed="right"
                prop="handleTime"
                header-align="center"
                align="center"
                min-width="160"
                :show-overflow-tooltip="true"
                :key="14"
            >
                <template slot="header" slot-scope="scope">
                    <el-popover placement="bottom" trigger="click" width="300">
                        <span slot="reference" style="cursor: pointer;margin-top:10px">
                            处理完成时间
                            <i class="el-icon-search"></i>
                            <!-- <span>
                <div> <i class="el-icon-caret-top"></i></div>
                <div> <i class="el-icon-caret-bottom"></i></div>
                            </span>-->
                        </span>
                        <div>
                            <div style="display: inline-block;padding:12px">
                                <el-date-picker
                                    v-model="handleTimeValue"
                                    type="daterange"
                                    range-separator="至"
                                    start-placeholder="开始日期"
                                    end-placeholder="结束日期"
                                ></el-date-picker>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button plain size="mini" @click="()=>{handleTimeValue=[];handleTimeLE='';handleTimeGE='';getDataList()}">重置</el-button>
                                <el-button
                                    @click="searchChoseTimefunc(handleTimeValue,3)"
                                    size="mini"
                                    type="primary"
                                >搜索</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
                <template slot-scope="scope">
                    <span>{{scope.row.handleTime?scope.row.handleTime:'--'}}</span>
                </template>
            </el-table-column>

            <el-table-column
                v-if="activedTab=='processed'||activedTab=='all'"
                label="办结状态"
                fixed="right"
                prop="endStatusName"
                header-align="center"
                align="center"
                min-width="110"
                :key="15"
                :show-overflow-tooltip="true"
            >
                <template slot="header" slot-scope="scope">
                    <el-popover
                        placement="bottom"
                        width="200"
                        trigger="click"
                        :ref="`popover-${scope.$index}`"
                    >
                        <span
                            slot="reference"
                            style="cursor: pointer;margin-top:10px"
                            :style="{color:checkEndStatus.length>0?'#1890ff':''}"
                        >
                            办结状态
                            <img src="../../../../../assets/img/shaixuan.png" alt />
                        </span>
                        <div>
                            <div id="el-checkbox-group">
                                <el-checkbox-group v-model="checkEndStatus">
                                    <el-checkbox
                                        :label="item.code"
                                        v-for="(item,index) in checkEndStatusOptions"
                                        :key="index"
                                        class="check_box"
                                    >{{item.name}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button type="primary" size="mini" @click="getDataList">筛选</el-button>
                                <el-button size="mini" plain @click="cancelCheckEndStatus">重置</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
                <template  slot-scope="scope">
                    <!-- endStatus: 2未办结 1 已办结  4已终止 3已失效 -->
                    <el-tag :type="findType(scope.row.endStatus)">{{scope.row.endStatusName}}</el-tag>
                </template>
            </el-table-column>
            <el-table-column
                v-if="activedTab=='processed'||activedTab=='all'"
                label="最终处理结果"
                fixed="right"
                prop="lastHandleStatusName"
                align="center"
                min-width="130"
                :key="16"
                :show-overflow-tooltip="true"
            >
                <template slot="header" slot-scope="scope">
                    <el-popover
                        placement="bottom"
                        width="200"
                        trigger="click"
                        :ref="`popover-${scope.$index}`"
                    >
                        <span
                            slot="reference"
                            style="cursor: pointer;margin-top:10px"
                            :style="{color:checkLastHandleStatus.length>0?'#1890ff':''}"
                        >
                            最终处理结果
                            <img src="../../../../../assets/img/shaixuan.png" alt />
                        </span>
                        <div>
                            <div id="el-checkbox-group">
                                <el-checkbox-group v-model="checkLastHandleStatus">
                                    <el-checkbox
                                        :label="item.code"
                                        v-for="(item,index) in checkReceiveOptions"
                                        :key="index"
                                        class="check_box"
                                    >{{item.name}}</el-checkbox>
                                </el-checkbox-group>
                            </div>
                            <div style="text-align: right; margin: 10px">
                                <el-button type="primary" size="mini" @click="getDataList">筛选</el-button>
                                <el-button size="mini" plain @click="cancelLastHandleStatus">重置</el-button>
                            </div>
                        </div>
                    </el-popover>
                </template>
                <template slot-scope="scope">
                    <span>{{scope.row.lastHandleStatusName?scope.row.lastHandleStatusName:'--'}}</span>
                </template>
            </el-table-column>
            <el-table-column
                label="异常状态"
                fixed="right"
                prop="revokeStatusName"
                header-align="center"
                align="center"
                min-width="130"
                :key="17"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span
                        class="redText"
                        @click="goExceptionDetail(scope.row)"
                    >{{scope.row.revokeStatus|filterRevokeStatus}}</span>
                </template>
            </el-table-column>
            <el-table-column
                v-if="activedTab=='all'"
                label="修改人"
                prop="updateUser"
                header-align="center"
                align="center"
                min-width="120"
                :show-overflow-tooltip="true"
                :key="22"
            ></el-table-column>
            <el-table-column
                v-if="activedTab=='all'"
                label="修改时间"
                prop="updateTime"
                header-align="center"
                align="center"
                min-width="180"
                sortable
                :show-overflow-tooltip="true"
                :key="23"
            ></el-table-column>
            <el-table-column label="操作" align="center" fixed="right" min-width="100" :key="18">
                <template slot-scope="scope">
                    <el-button type="text" size="small" title="查看" @click="getDetail(scope.row)">查看</el-button>
                    <!-- 此按钮不会显示 除非在步骤一填写投诉信息 前后端开发自动保存 才会有待提交数据-->
                    <el-button
                        type="text"
                        size="small"
                        title="删除"
                        @click="deteleRow(scope.row)"
                        v-if="scope.row.receiveStatusName=='待提交'"
                    >删除</el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            background
            layout="total, prev, pager, next"
            :page-size="pageSize"
            :total="total"
            :current-page="pageIndex"
            @size-change="sizeChangeHandle"
            @current-change="currentChangeHandle"
        ></el-pagination>
    </div>
</template>

<script>
import { complaintDelete } from "@/server/complaint";
import moment from 'moment';
export default {
    props: ["activedTab", "tableHeight", "filterStatus", "search", "filterParams"],
    data() {
        return {
            tableData: [],
            dataListLoading: false,
            checkReceiveStatus: [],
            checkReceiveOptions: [],
            checkEndStatus: [],
            checkOwerDeptHandleResult: [],
            checkLastHandleStatus: [],
            checkEndStatusOptions: [],
            pageSize: 10, //每页条数
            pageIndex: 1, //当前页
            total: 8, //总条数
            processingStateList: [
                { label: "已受理", value: 3 },
                { label: "待受理", value: 1 },
                { label: "不予受理", value: 2 }
            ],
            actived: "",
            projectForm: {
                bidSectionName: "",
                receiveStatus: 1, //受理状态字段过滤 待受理
                complaintCode: "",
                bidSectionNameOrCode: ""
            },
            neOwerDeptHandleResultList: [],
            // 搜索时间

            submitTimeValue: [],
            receiveTimeValue: [], // 投诉受理时间
            handleTimeValue: [], // 处理完成时间
            complaintCodeSearch: "", // 投诉编号搜索
            receiveOrgNameSearch: "",
            handleRateNameList: [
                {
                    label: "正常",
                    value: 0
                },
                {
                    label: "黄色预警",
                    value: 1
                },
                {
                    label: "橙色预警",
                    value: 2
                },
                {
                    label: "红色预警",
                    value: 3
                }
            ],
            ndleRateChoseList:[],
            handleRateChoseList: [],
            receiveTimeLE:'',
            receiveTimeGE:'',
            handleTimeLE:'',
            handleTimeGE:'',
            submitTimeLE:'',
            submitTimeGE:'',
            bidSectionNameSearch:'',
            bidSectionCodeSearch:'',
            sortParams: {
            order: "",
            prop: ""
            },
        }; 
    },
    watch: {
        activedTab: {
            handler() {
                //重置过滤状态
                this.checkReceiveStatus = [];
                this.checkEndStatus = [];
                this.checkLastHandleStatus = [];

                this.$nextTick(() => {
                    this.$refs.othertableRef.doLayout();
                });
            }
        },
        filterStatus: {
            immediate: true,
            handler(val) {
                this.setCurrentTableList(val);
            }
        },
    },
    mounted() {
        this.$nextTick(()=>{
            this.getDataList();
            this.getDic();
        })
    },
    activated(){
        this.$nextTick(()=>{
            this.getDataList();
            this.getDic();
        })
    },
    filters: {
        filterRevokeStatus(val) {
            if (!val) {
                return "";
            }
            let str = "";
            switch (val) {
                case 2:
                    str = "有异常待处理";
                    break;
                default:
                    str = "";
                    break;
            }
            return str;
        }
    },
    methods: {
        findType(status){
            // endStatus: 2未办结 1 已办结  4已终止 3已失效
            let str=''
            switch (status) {
                    case 1:
                     str="success"
                    break;
                    case 2:
                     str="danger"
                    break;
                    case 3:
                    case 4:
                     str="info"
                    break;
                default:
                    break;
            }
            return str

        },
        setCurrentTableList(val) {
            this.projectForm.receiveStatus = val;
            //   1待受理 2待处理 3已处理 4异常处理 5全部
            this.actived = val;
            this.checkOwerDeptHandleResult = [];
            this.neOwerDeptHandleResultList = [];

            if (this.projectForm.receiveStatus == 2) {
                //待处理
                this.projectForm.receiveStatus = null;
                this.checkOwerDeptHandleResult = [8];
                this.neOwerDeptHandleResultList = [];
            }
            if (this.projectForm.receiveStatus == 3) {
                //已处理
                this.projectForm.receiveStatus = null;
                this.checkOwerDeptHandleResult = [];
                this.neOwerDeptHandleResultList = [8];
            }
            if (this.projectForm.receiveStatus == 5) {
                //全部
                this.projectForm.receiveStatus = null;
                this.checkOwerDeptHandleResult = [];
                this.neOwerDeptHandleResultList = [];
            }
            this.getDataList();
        },
        goExceptionDetail(row) {
            removeTabHandle("offline_complaints");
            this.$router.push({
                name: "online_complaints_exception_detail",
                query: { id: row.id, type: "exception" }
            });
        },
        getDic() {
            //         listWarnGrade().then((res) => {
            //       if(res.data.code==1){
            //         this.treatmentAgingList=[];
            //         this.treatmentAgingList=[
            //           {
            //             name:'正常',
            //             type:'0'
            //           }
            //         ];
            //         for(var i in res.data.data){
            //           this.treatmentAgingList.push(res.data.data[i])
            //         }

            //       }
            //   })

            this.$httpReq({
                url: `/complaint/listEnum/HandleStatusEnum`,
                method: "get"
            }).then(({ data }) => {
                if (data.code == 1) {
                    this.checkReceiveOptions = data.data;
                } else {
                    this.$message.error(data.msg);
                }
            });

            this.$httpReq({
                url: `/complaint/listEnum/ComplaintEndStatusEnum`,
                method: "get"
            }).then(({ data }) => {
                if (data.code == 1) {
                    this.checkEndStatusOptions = data.data;
                } else {
                    this.$message.error(data.msg);
                }
            });
        },
        indexMethod(index) {
            return (this.pageIndex - 1) * this.pageSize + index + 1;
        },
        //分页---------------------------------------------------
        sizeChangeHandle(val) {
            this.pageSize = val;
            this.pageIndex = 1;
            this.getDataList();
        },
        currentChangeHandle(val) {
            this.pageIndex = val;
            this.getDataList();
        },
        cancelHandleRateNameList() {
            //重置受理状态
            this.handleRateChoseList = [];
            this.getDataList();
        },
        cancelReceive() {
            //重置受理状态
            this.checkReceiveStatus = [];
            this.getDataList();
        },
        cancelDeptHandleResult() {
            //重置本部门状态
            this.checkOwerDeptHandleResult = [];
            this.getDataList();
        },
        cancelLastHandleStatus() {
            //最终处理
            this.checkLastHandleStatus = [];
            this.getDataList();
        },
        cancelCheckEndStatus() {
            this.checkEndStatus = [];
            this.getDataList();
        },
        searchChoseTimefunc(time,type) {
            // 清空所有筛选项
            this.receiveTimeLE=''
            this.receiveTimeGE=''
            this.handleTimeLE=''
            this.handleTimeGE=''
            this.submitTimeLE=''
            this.submitTimeGE=''
            this.complaintCodeSearch=''
            this.receiveOrgNameSearch=""
            this.bidSectionNameSearch=''
            this.bidSectionCodeSearch=''
            // 1 投诉提交时间 2投诉受理时间  3处理完成时间
            switch (type) {
                case 1:
                    this.submitTimeLE=moment(time[0]).format("YYYY-MM-DD")||""
                    this.submitTimeGE=moment(time[1]).format("YYYY-MM-DD")||''
                    break;
                case 2:
                    this.receiveTimeLE=moment(time[0]).format("YYYY-MM-DD")||""
                    this.receiveTimeGE=moment(time[1]).format("YYYY-MM-DD")||''
                     break;
                case 3:
                    this.handleTimeLE=moment(time[0]).format("YYYY-MM-DD")||""
                    this.handleTimeGE=moment(time[1]).format("YYYY-MM-DD")||''
                    break;
                    //投诉编号 complaintCodeSearch 
                case 4:
                    this.complaintCodeSearch=time||''
                    break;
                case 5:
                    // 投诉受理部门receiveOrgNameSearch
                    this.receiveOrgNameSearch=time||""
                    break;
                case 6:
                      // 项目标段名称
                      this.bidSectionNameSearch=time||""
                    break;
                case 7:
                     // 项目标段编号
                     this.bidSectionCodeSearch=time||""
                    break;
                default:
                    break;
            }
           this.getDataList();
        },
        getDetail(row) {
            // 跳转详情
            removeTabHandle("offline_complaints");
            this.$router.push({
                name: "offline_complaints",
                query: {
                    id: row.id,
                    code: row.complaintCode,
                    tabActived: this.activedTab
                }
            });
            sessionStorage.setItem("oneliner", JSON.stringify(row));
        },
        deteleRow(row) {
            complaintDelete({ id: row.id }).then(res => {
                if (res.data.code == 1) {
                    this.$message.success("删除成功");
                } else {
                    this.$message.error(res.data.data);
                }
            });
        },
        formatterStatusClass(historyId) {
            switch (historyId) {
                case 3:
                    return "icon-point icon-point-success";
                    break;
                case 1:
                    return "icon-point icon-point-verificationing";
                    break;
                case 2:
                    return "icon-point icon-point-danger";
                    break;
                default:
                    return "";
                    break;
            }
        },
        formatterResultClass(historyId) {
            // 1 已处理 2已交办 3已转办 4待处理 5相互配合调查 6已移交 7 已退回 8 待处理 9 已终止
            switch (historyId) {
                case 1:
                    return "icon-point icon-point-success";
                    break;
                case 4:
                case 8:
                    return "icon-point icon-point-verificationing";
                    break;
                case 2:
                case 6:
                    return "icon-point icon-point-danger";
                    break;
                case 9:
                    return "icon-point icon-point-info";
                    break;
                default:
                    // 3 7
                    return "icon-point isBlue";
                    break;
            }
        },
        sortChange(column, prop, order) {
        this.sortParams.prop = prop || column.prop;
        this.sortParams.order = order || column.order;
        this.getDataList();
        },
        //专家评审记录列表
        getDataList(type, parentSearchKey) {
            let mySearch =
                type == "1" ? parentSearchKey.bidSectionNameOrCode : "";
            this.dataListLoading = true;
            this.$httpReq({
                url: `/complaint/list`,
                method: "post",
                data: {
                    page: this.pageIndex,
                    rows: this.pageSize,
                    filter: {
                        receiveStatus: this.projectForm.receiveStatus,
                        superviseDeptCodeList:type=="1"?parentSearchKey.superviseDeptCodeList:[],
                       
                        receiveStatusList: this.checkReceiveStatus,
                        owerDeptHandleResultList: this
                            .checkOwerDeptHandleResult, //待处理
                        lastHandleStatusList: this.checkLastHandleStatus,
                        endStatusList: this.checkEndStatus,
                        neOwerDeptHandleResultList: this
                            .neOwerDeptHandleResultList,

                        isEnable : this.activedTab=='all'?false:true ,// 非异常处理 tab=全部为false，其他则为true
                        handleRateList:this.handleRateChoseList||[], //处理时效 字段待对接
                        receiveTimeLE: this.receiveTimeLE||null,
                        receiveTimeGE:this.receiveTimeGE||null,
                        handleTimeLE: this.handleTimeLE||null,
                        handleTimeGE:this.handleTimeGE||null,
                        submitTimeLE: this.submitTimeLE||null,
                        submitTimeGE:this.submitTimeGE||null,
                        complaintCode:this.complaintCodeSearch?this.complaintCodeSearch:( type == "1" ? parentSearchKey.complaintCode : ""),
                        receiveOrgName:this.receiveOrgNameSearch,
                        bidSectionName:this.bidSectionNameSearch?this.bidSectionNameSearch:(type == "1" ? parentSearchKey.bidSectionName : ""),
                        bidSectionCode:this.bidSectionCodeSearch||'',
                        ...this.filterParams,
                    },
                    searchKey: mySearch || "",
                    orderBy:this.sortParams.prop && this.sortParams.order
                            ?'a.'+ this.sortParams.prop +(this.sortParams.order == "ascending" ? " asc" : " desc") : "",
                }
            }).then(({ data }) => {
                if (data) {
                    this.tableData = data.rows;
                    this.total = data.total;
                    this.dataListLoading = false;
                }
            });
        },
        add() {
            removeTabHandle("offline_complaints");
            this.$router.push({
                name: "offline_complaints",
                query: {}
            });
        }
    }
};
</script>

<style lang="scss" scoped>
.isBlue {
    background: #1890ff;
}
.otherHanfleList {
    .redText {
        cursor: pointer;
        color: red;
    }
}
#el-checkbox-group {
    /deep/ .el-checkbox {
        margin-left: 30px;
        line-height: 30px;
    }
}
</style>